import { Box, Card, CardContent, CardHeader, Collapse, Typography } from "@mui/material";
import { ReactNode, useState } from "react";
import { CardExpandButton } from "./CardExpandButton";
import { ITagProps } from "./Tag";
import { useStyle } from "./style";
import { TagList } from "./TagList";

interface IParams {
    children: ReactNode;
    footerBackgroundColor?: string;
    FooterComponent?: JSX.Element;
    subheader?: string;
    SummaryComponent?: JSX.Element;
    tags?: ITagProps[];
    title: string;
}

export const CardWithTitle = (props: IParams) => {
    const { children, footerBackgroundColor, FooterComponent, subheader, SummaryComponent, tags, title } = props;
    const [expand, setExpand] = useState(false);
    const isExpandable = Boolean(SummaryComponent);
    const { classes } = useStyle({ cardPaddingBottom: expand && !FooterComponent ? 10 : 0 });

    const renderContentComponent = () => {
        if (isExpandable) {
            return (
                <>
                    {SummaryComponent}
                    <Collapse in={expand} unmountOnExit>
                        {children}
                    </Collapse>
                </>
            );
        }

        return children;
    };

    const renderFooterComponent = () => {
        if (!FooterComponent || (isExpandable && !expand)) {
            return undefined;
        }

        return (
            <Box style={{ backgroundColor: footerBackgroundColor, paddingBottom: 10, paddingTop: 15 }}>
                {FooterComponent}
            </Box>
        );
    };

    return (
        <Box className={classes.boxContainer}>
            <Card className={classes.card} elevation={2}>
                <CardHeader
                    className={`card-header ${classes.cardHeaderContainer}`}
                    disableTypography
                    subheader={
                        <>
                            {subheader && (
                                <Typography align="center" color="inherit" variant="large">
                                    {subheader}
                                </Typography>
                            )}
                            {tags && <TagList tags={tags} />}
                        </>
                    }
                    title={
                        <Typography align="center" color="inherit" variant="h2">
                            {title}
                        </Typography>
                    }
                />
                <CardContent>
                    <div className="card-header__circle" />
                    {renderContentComponent()}
                </CardContent>
                {renderFooterComponent()}
            </Card>
            {isExpandable && (
                <CardExpandButton expand={expand} footerBackgroundColor={footerBackgroundColor} setExpand={setExpand} />
            )}
        </Box>
    );
};
